/* eslint-disable react/require-default-props */

/* eslint-disable no-sequences */

/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { MaterialUiIcons } from '@gscope-mfe/common-libs';
import { MaterialUiCore } from '@gscope-mfe/common-libs';
import cssVars from 'css-vars-ponyfill';
const { makeStyles } = MaterialUiCore;
const { SnackbarContent } = MaterialUiCore;
const { IconButton } = MaterialUiCore;
const CloseIcon = MaterialUiIcons.Close;
const useStyles = makeStyles((theme) => ({
    root: {
        flexWrap: 'nowrap',
        boxShadow: 'none',
        minHeight: 34,
        height: 'auto',
        borderRadius: 2,
        padding: '0px 16px',
    },
    success: {
        backgroundColor: 'var(--alertGreen)',
        borderColor: 'var(--alertGreen)',
    },
    successSubtle: {
        border: 'solid 1px var(--alertGreen)',
        backgroundColor: '#f1f7ee',
    },
    error: {
        backgroundColor: 'var(--alertRed)',
        borderColor: 'var(--alertRed)',
    },
    errorSubtle: {
        border: 'solid 1px var(--alertRed)',
        backgroundColor: '#fef7f7',
    },
    warning: {
        backgroundColor: 'var(--pumpkinOrange)',
        borderColor: 'var(--pumpkinOrange)',
    },
    warningSubtle: {
        border: 'solid 1px var(--pumpkinOrange)',
        backgroundColor: '#fff9e9',
    },
    icon: {
        fontSize: 16,
        color: 'var(--black)',
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: theme.spacing(1),
    },
    successIcon: {
        color: 'var(--black)',
    },
    successAction: {
        '&:hover': {
            backgroundColor: 'var(--alertGreen)',
        },
    },
    errorIcon: {
        color: 'var(--white)',
    },
    errorAction: {
        '&:hover': {
            backgroundColor: 'var(--alertRed)',
        },
    },
    warningIcon: {
        color: 'var(--white)',
    },
    warningAction: {
        '&:hover': {
            backgroundColor: 'var(--pumpkinOrange)',
        },
    },
    subtleIcon: {
        color: 'var(--black)',
    },
    linkContainer: {
        marginLeft: '5px',
    },
    link: {
        color: 'var(--white)',
        textDecoration: 'underline',
        '&:hover': {
            color: 'var(--white)',
        },
    },
    text: {
        textAlign: 'left',
        margin: '0px',
        marginRight: '5px',
    },
    successLink: {
        color: 'var(--black)',
        textDecoration: 'underline',
        '&:hover': {
            color: 'var(--black)',
        },
    },
    globalClass: {
        '& .MuiSnackbarContent-message': {
            width: '90%',
            padding: '5px 0px',
        },
    },
    messageContainer: {
        display: 'flex',
        margin: 'auto',
        alignItems: 'center',
    },
    iconContainer: {
        '&:hover': {
            backgroundColor: 'inherit',
        },
    },
}));
export default function Message(props) {
    const classes = useStyles();
    const { className, message, onClose, variant, showCloseBtn, style, link, linkText, type } = props;
    const iconClass = type !== 'global' && style === 'outlined' ? 'subtleIcon' : `${variant}Icon`;
    const messageClass = type !== 'global' && style === 'outlined' ? `${variant}Subtle` : variant;
    const iconAction = style === 'filled' || (type && type === 'global') ? classes[`${variant}Action`] : null;
    const globalClass = type && type === 'global' ? 'globalClass' : null;
    const linkTextClass = variant === 'success' ? 'successLink' : 'link';
    const iconMapping = {
        success: 'icon-Check-Circle-18',
        error: 'icon-Exclamation-18',
        warning: 'icon-Warning-18',
        alert: 'icon-Check-Circle-18',
    };
    const iconClasses = type === 'alert' ? `sct-icon ${iconMapping[type]}` : `sct-icon ${iconMapping[variant]}`;
    React.useEffect(() => {
        //transpile css style
        const ua = window.navigator.userAgent;
        const trident = ua.indexOf('Trident/');

        if (trident > 0) {
            cssVars({});
        }
    });
    return (
        <SnackbarContent
            className={clsx(classes[messageClass], classes.root, className, classes[globalClass])}
            aria-describedby="client-snackbar"
            message={
                <div id="client-snackbar" className={clsx(classes.messageContainer, classes[iconClass])}>
                    <IconButton size="small" className={clsx(classes.iconContainer)}>
                        <span className={clsx(classes.icon, classes.iconVariant, classes[iconClass], iconClasses)} />
                    </IconButton>
                    <p
                        className={clsx(classes.text)}
                        dangerouslySetInnerHTML={{
                            __html: message,
                        }}
                    />
                    {(type === 'global' || type === 'alert') && link && linkText && (
                        <span className={classes.linkContainer}>
                            <a className={classes[linkTextClass]} href={link} target="_blank">
                                {linkText}
                            </a>
                        </span>
                    )}
                </div>
            }
            action={[
                showCloseBtn && type !== 'alert' && (
                    <IconButton className={iconAction} size="small" key="close" aria-label="close" onClick={onClose}>
                        <CloseIcon fontSize="small" className={(classes.icon, classes[iconClass])} />
                    </IconButton>
                ),
            ]}
        />
    );
} // Specifies the default values for props:

Message.defaultProps = {
    showCloseBtn: false,
};
Message.propTypes = {
    className: PropTypes.string,
    message: PropTypes.string.isRequired,
    onClose: PropTypes.func,
    variant: PropTypes.oneOf(['error', 'success', 'warning']).isRequired,
    showCloseBtn: PropTypes.bool,
    style: PropTypes.oneOf(['filled', 'outlined']).isRequired,
    link: PropTypes.string,
    linkText: PropTypes.string,
    type: PropTypes.string,
};
